var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDownMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07651 0.611055C1.7921 0.309916 1.31742 0.296354 1.01628 0.580763C0.715145 0.865171 0.701583 1.33985 0.985992 1.64099L8.12677 9.20181C8.13974 9.2161 8.15336 9.23 8.16763 9.24347C8.30086 9.3693 8.46806 9.43681 8.63772 9.44689C8.83722 9.45886 9.041 9.39155 9.19776 9.2435C9.21247 9.22961 9.22649 9.21526 9.23983 9.2005L16.3794 1.64096C16.6638 1.33982 16.6502 0.865144 16.3491 0.580735C16.048 0.296326 15.5733 0.309888 15.2889 0.611027L8.75538 7.52884C8.71592 7.57063 8.64944 7.57063 8.60998 7.52884L2.07651 0.611055Z",
    fill: "#29313D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownMedium);
export default __webpack_public_path__ + "static/media/chevron-down-medium.30fdfd6e0523bd561308be615a5e4824.svg";
export { ForwardRef as ReactComponent };